import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import gsap from 'gsap';
import {CONSTANTES} from '../../../../shared/constanst/url-scrolls-header';

@Component({
  selector: 'app-bloque-de-bienvenida',
  templateUrl: './bloque-de-bienvenida.component.html',
  styleUrl: './bloque-de-bienvenida.component.css'
})
export class BloqueDeBienvenidaComponent {
  @Input() pageData;
  @ViewChild('titleElement') titleElement: ElementRef;

  rutaImagen: string = CONSTANTES.LOGO_DISEÑO_LINEAS_NEGRAS;

  constructor(private router: Router) {

  }

  ngAfterViewInit(): void {
    // Dividir el texto en letras
    const text = this.titleElement.nativeElement;
    text.innerHTML = text.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
    const timeline = gsap.timeline();

    // Animación de letras
    timeline.staggerFromTo(
      ".letter",
      0.7,
      { ease: "back.out(2.7)", opacity: 0, y: -80 },
      { ease: "back.out(1.7)", opacity: 1, y: 0 },
      0.06
    );
  }

  irAInscribirse() {
    this.router.navigate(['/inscribirse']);
  }
}
